export default "__VITE_ASSET__BWHBi44u__"